<template>
    <aside>
        <header class="mb-3 d-flex">
            <search-input v-model="search" class="flex-grow-1"/>

            <b-button
                :to="{ name: 'foundations.create' }"
                :title="$t('Create new foundation')"
                variant="primary"
                class="ml-3"
            >
                <fa icon="plus" :title="$t('Create new foundation')"/>
            </b-button>
        </header>

        <nav>
            <b-list-group tag="ul">
                <b-list-group-item
                    v-for="foundation in items"
                    :key="foundation.id"
                    :to="{ name: 'foundations.edit', params: { foundationId: foundation.id } }"
                    class="flex-column align-items-start mb-1"
                    tag="li"
                >
                    <div class="d-flex w-100 justify-content-between">
                        <h2 class="h5 mb-1">
                            {{ foundation.name }}
                        </h2>
                    </div>

                    <small class="d-block">
                        {{ foundation.short_name }}
                    </small>
                </b-list-group-item>
            </b-list-group>
        </nav>
        <b-pagination
            v-if="showPagination"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            limit="3"
        />

        <b-alert :show="!pending && !items.length" variant="warning">
            {{ $t('To create a new foundation use the plus button') }}
        </b-alert>

        <div v-show="pending" class="text-center mt-1">
            <b-spinner/>
        </div>
    </aside>
</template>
<script>
    import fetchPaginatedData from '@/mixins/fetchPaginatedData';
    import SearchInput from "@/components/SeachInput";

    export default {
        name: 'Foundations',
        components: {SearchInput},
        mixins: [fetchPaginatedData],
        computed: {
            apiUrl() {
                return '/api/foundations'
            }
        },
        created() {
            let _this = this;
            this.$root.$on('created::foundation', function(data) {
                _this.foundations.unshift(data);
                _this.totalRows += 1;
                if (_this.foundations.length > _this.perPage) {
                    _this.foundations.pop();
                }
            });

            this.$root.$on('updated::foundation', function(data) {
                let index = _this.foundations.findIndex(({id}) => id === data.id);
                _this.foundations.splice(index, 1, data);
            });
        },
    };
</script>
